/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { BOT_DEPLOYMENTS_CHANNELS } from '../../../constants/main';

/**
 * Get the supported platforms from a list of bot deployments.
 *
 * @param {Object} botDeployments The bot deployments object, as returned by the API
 * @returns {Array} Returns an array with the supported platforms
 */
export default function getSupportedPlatforms(botDeployments) {
  if (!botDeployments) {
    return [];
  }

  let platforms = [];

  platforms = Array.from(new Set(botDeployments?.items?.map((item) => {
    return item.platform;
  })));

  // Only show the platforms that are supported
  platforms = Array.from(new Set(botDeployments?.items?.map(item => item.platform)))
    .filter(platform =>
      [
        BOT_DEPLOYMENTS_CHANNELS.MICROSOFT_TEAMS.key,
        BOT_DEPLOYMENTS_CHANNELS.SLACK.key,
        BOT_DEPLOYMENTS_CHANNELS.VIBER.key,
        BOT_DEPLOYMENTS_CHANNELS.FACEBOOK.key
      ].includes(platform)
    );

  return platforms;
}
